exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.field--3SBoVRu1{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-negative:0;flex-shrink:0;position:relative;margin:0 2rem 1rem;min-height:4.5rem}@media (max-width:599px){.field--3SBoVRu1{margin:0 1rem;min-height:2rem}}", ""]);

// exports
exports.locals = {
	"field": "field--3SBoVRu1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/sign_up/shared/field/styles.scss
// module id = 1042
// module chunks = 0